import { isEmpty } from '@jjj/components';
import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';
import { keyBy } from '../../../../helpers/core';
import { t } from '../../../../i18n';

const modalInitState = {
  addExceptionLoading: false,
  isModalVisible: false,
  formData: {},
  exceptionForm: {
    exception_reason: null,
    exception_message: null,
    document: null,
  },
  loadingFormData: false,
  exception_reason: null,
  chosenInfraction: null,
  action: null,
  fileList: null,
};

const initState = {
  loading: false,
  isInterestModalShown: false,
  sectorInterestId: undefined,
  records: [],
  filters: null,
  ...modalInitState,
};

function onLoadRequest(state) {
  return { ...state, loading: true };
}

function onLoadSuccess(state, { payload }) {
  const { records, totalCount, filteredCount, sortableColumns, filters } = payload;

  const updatedRecords = records.map(record => {
    record.actions = [{ key: 'show_job_details_page' }, ...(record.actions || [])];

    return record;
  });

  return {
    ...state,
    filteredCount,
    filters,
    loading: false,
    records: updatedRecords,
    sortableColumns,
    totalCount,
  };
}

function onClearStore() {
  return { ...initState };
}

function validate(attr, value) {
  let error = '';

  if (attr === 'exception_reason') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.talent.add_exception_select_label') });
    }
  }

  if (attr === 'exception_message') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.talent.add_exception_select_label') });
    }
  }

  return error;
}

function onClearModalStore(state) {
  return { ...state, ...modalInitState };
}

function onHideModal(state) {
  return onClearModalStore(state);
}

function onAddExceptionRequest(state) {
  return { ...state, addExceptionLoading: true };
}

function onAddExceptionSuccess() {
  return onHideModal();
}

function onChangeValue(state, { payload }) {
  const { attr, value } = payload;
  const { exceptionForm } = state;

  exceptionForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    exceptionForm: {
      ...exceptionForm,
    },
  };
}

function setFileList(state, { payload }) {
  return {
    ...state,
    fileList: payload?.fileList,
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.exceptionForm);
  const exceptionForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    exceptionForm,
  };
}

function onLoadFormDataSuccess(state, { payload }) {
  return { ...state, loadingFormData: false, formData: payload };
}

function onLoadFormData(state) {
  return {
    ...state,
    loadingFormData: true,
  };
}

function onShowModal(state, { payload }) {
  const { exceptionForm } = state;

  const propsArray = Object.keys(exceptionForm);
  const exceptionFormValidated = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: exceptionForm[prop],
      error: validate(prop, exceptionForm[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    isModalVisible: !state.isModalVisible,
    chosenInfraction: payload?.infraction,
    action: payload?.action,
    talentId: payload?.talentId,
    exceptionForm: exceptionFormValidated,
  };
}

export default createReducer(initState, {
  [actions.CLEAR_STORE]: onClearStore,
  [actions.LOAD_REQUEST]: onLoadRequest,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  /* Add Exception modal */
  [actions.ADD_EXCEPTION_REQUEST]: onAddExceptionRequest,
  [actions.ADD_EXCEPTION_SUCCESS]: onAddExceptionSuccess,
  [actions.CHANGE_VALUE]: onChangeValue,
  [actions.CLEAR_MODAL_STORE]: onClearModalStore,
  [actions.HIDE_MODAL]: onHideModal,
  [actions.LOAD_FORM_DATA_SUCCESS]: onLoadFormDataSuccess,
  [actions.SHOW_MODAL]: onShowModal,
  [actions.LOAD_FORM_DATA_REQUEST]: onLoadFormData,
  [actions.TOUCH]: onTouch,
  [actions.SET_FILE_LIST]: setFileList,
});
